import { useCallback, useEffect, useState } from "react";
import { v4 } from "uuid";

export const useSearchIsochroneStates = () => {
  const [isochrones, setIsochrones] = useState<
    Map<
      string,
      {
        lat: number;
        lng: number;
        walking: boolean;
        cycling: boolean;
        driving: boolean;
        minutes: number;
      }
    >
  >(new Map());

  const addIsochrone = useCallback(
    (newIsochrone: {
      lat: number;
      lng: number;
      walking: boolean;
      cycling: boolean;
      driving: boolean;
      minutes: number;
    }) => {
      const id = v4();
      setIsochrones((prev) => {
        const updatedIsochrones = new Map(prev);
        updatedIsochrones.set(id, newIsochrone);
        return updatedIsochrones;
      });
    },
    []
  );

  const removeIsochrone = useCallback((id: string) => {
    setIsochrones((prev) => {
      const updatedIsochrones = new Map(prev);
      updatedIsochrones.delete(id);
      return updatedIsochrones;
    });
  }, []);

  const clearIsochrones = useCallback(() => {
    setIsochrones(new Map());
  }, []);

  useEffect(() => {
    return () => {
      setIsochrones(new Map());
    };
  }, []);

  return {
    isochrones,
    setIsochrones,
    addIsochrone,
    removeIsochrone,
    clearIsochrones
  };
};

export type SearchIsochroneStatesType = ReturnType<
  typeof useSearchIsochroneStates
>;
